// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"94dd9171","726":"d952dc25","787":"fb3bf430"}[chunkId] + ".chunk.js";
};